import { render, staticRenderFns } from "./ClienteListaUsuario.vue?vue&type=template&id=68980126&scoped=true"
import script from "./ClienteListaUsuario.vue?vue&type=script&lang=js"
export * from "./ClienteListaUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68980126",
  null
  
)

export default component.exports